import React from "react";

import ls from './ConfigEditor.less';
import Icon from "antd/lib/icon";

export function EditorModeButton({value, onChange}) {

  return <button id={ls.configBtn} onClick={() => onChange(!value)}><Icon type="edit" style={{color: value && '#f0f' }} /></button>;

}